/**
 * Prices for the Prior Art Search products.
 *
 * A separate, DEPENDENCY-FREE module on purpose. These constants live here
 * rather than in `searchAccess.ts` because the frontend needs them too, and
 * `searchAccess.ts` imports the `search_credits` table, which pulls in
 * `@mindstudio-ai/agent` — a backend-only package that cannot be bundled for
 * the browser. Importing the prices from there built fine in dev and failed the
 * production build at the bundling step.
 *
 * The rule this follows is the one `pricing.ts` already does: anything the
 * frontend shares must have no imports at all. Keep it that way.
 */

/** The two purchasable search tiers. */
export type SearchCreditType = 'plan' | 'full';

/** Integer cents. The single source of truth for both Stripe and the UI. */
export const SEARCH_PRICES_CENTS: Record<SearchCreditType, number> = {
  plan: 1499, // $14.99 Search Strategy Plan
  full: 49999, // $499.99 Full Automated Search (Search Strategy Plan included)
};
